import templateUrl from './trip-provider-details.html';

export const tripProviderDetailsComponent = {
    bindings: {
        details: '<',
        originName: '@',
        destinationName: '@',
        selectedServiceType: '<',
        onBack: '&',
        privateTravelTime: '@',
        privateTravelTimeUnit: '@'
    },

    templateUrl,

    controller: class TripProviderDetailsComponent {

        constructor(DateService) {
            'ngInject';

            this.dateService = DateService;
        }

        $onInit() {
            this.providerDetails = (this.selectedServiceType.name === 'Public Transit') ? this.details.details : [this.details];
            this.selectedPublicRoute = this._getPublicRouteDetails();
        }

        _getPublicRouteDetails() {
            return this.selectedServiceType.name === 'Public Transit' ? this.details : [];
        }

        _getClass(details, day) {
			return  details && day ?  details.daysOfOperation[day] === true ? 'activeDay' : 'inActiveDay' : '';
		}

        _getTime(time) {
			return this.dateService.getFormattedTime(time);
		}
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/trip-provider-details/trip-provider-details.component.js